const PointOfSaleIcon = (
  <svg
    className="fill-current"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M12,22c.685,0,1.354-.07,2-.202v2.021c-.652,.11-1.317,.181-2,.181v-2ZM12,0C5.383,0,0,5.383,0,12c0,4.43,2.419,8.297,6,10.376v-2.395c-2.423-1.827-4-4.719-4-7.981C2,6.486,6.486,2,12,2s10,4.486,10,10c0,2.241-.75,4.305-2,5.974v2.945c2.448-2.198,4-5.377,4-8.919C24,5.383,18.617,0,12,0Zm4.608,8.229c-.939,.85-2.486,3.027-2.606,6.102-.039,1.705,.469,3.601,1.998,5.462v4.207h2V8.737c-.004-.629-.857-1.004-1.392-.507Zm-3.608,5.271v-5.5h-2v5.5c0,.276-.224,.5-.5,.5h-.5v-6h-2v6h-.5c-.276,0-.5-.224-.5-.5v-5.5h-2v5.5c0,1.378,1.122,2.5,2.5,2.5h.5v8h2v-8h.5c1.378,0,2.5-1.122,2.5-2.5Z" />
  </svg>
);

export default PointOfSaleIcon;